import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { menuData } from '../../data/menuData';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeNested, setActiveNested] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
  }, [isMobileOpen]);

  return (
    <>
      <nav className={`fixed w-full top-0 z-50 transition-all duration-700 ease-in-out ${
        scrolled || isMobileOpen
          ? 'bg-[#050505]/95 backdrop-blur-xl border-b border-white/5 py-4 shadow-2xl' 
          : 'bg-transparent py-6'
      }`}>
        <div className="max-w-[95rem] mx-auto px-6 lg:px-12">
          <div className="flex justify-between items-center">
            
            <Link to="/" className="flex items-center gap-4 group z-50">
              <div className={`transition-opacity duration-500 ${scrolled || isMobileOpen ? 'opacity-100' : 'opacity-0 md:opacity-100'}`}>
                <h1 className="font-serif text-lg md:text-xl font-semibold tracking-[0.2em] uppercase text-white leading-none">
                  Gran Logia <span className="font-light text-[#C5A059]">Perú</span>
                </h1>
              </div>
            </Link>

            <div className="hidden lg:flex items-center gap-6">
              {menuData.map((item, index) => (
                <div 
                  key={index} 
                  className="relative py-2"
                  onMouseEnter={() => setActiveDropdown(index)}
                  onMouseLeave={() => {
                    setActiveDropdown(null);
                    setActiveNested(null);
                  }}
                >
                  <Link 
                    to={item.path} 
                    className={`flex items-center gap-1 text-[11px] tracking-[0.25em] uppercase transition-all duration-300 font-sans ${
                      item.isButton 
                        ? 'text-[#050505] bg-[#C5A059] px-6 py-3 hover:bg-white' 
                        : 'text-gray-300 hover:text-[#C5A059]'
                    }`}
                  >
                    {item.title}
                  </Link>

                  {/* Dropdown Desktop (CON PUENTE TRANSPARENTE 'pt-4') */}
                  {item.submenus && activeDropdown === index && (
                    <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 w-64 z-50">
                      <div className="bg-[#0a0a0a]/95 backdrop-blur-xl border border-white/10 rounded-sm shadow-2xl overflow-hidden animate-fade-in">
                        {item.submenus.map((subItem, subIndex) => (
                          <div key={subIndex} className="relative group/sub" onMouseEnter={() => setActiveNested(subIndex)}>
                            <Link
                              to={subItem.path}
                              className="block px-6 py-4 text-[11px] font-sans tracking-[0.1em] uppercase text-gray-400 hover:text-white hover:bg-white/5 transition-colors border-b border-white/5 last:border-0"
                            >
                              {subItem.title}
                            </Link>

                            {/* Tercer Nivel Desktop (CON PUENTE TRANSPARENTE 'pl-1') */}
                            {subItem.nested && activeNested === subIndex && (
                              <div className="absolute left-full top-0 pl-1 h-full z-50">
                                <div className="bg-[#0a0a0a]/95 backdrop-blur-xl border border-white/10 shadow-2xl h-full min-h-full">
                                  {subItem.nested.map((nestedItem, nestedIndex) => (
                                    <Link
                                      key={nestedIndex}
                                      to={nestedItem.path}
                                      className="block px-6 py-4 text-[11px] font-sans tracking-[0.1em] uppercase text-gray-400 hover:text-white hover:bg-white/5 transition-colors border-b border-white/5"
                                    >
                                      {nestedItem.title}
                                    </Link>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <button 
              className="lg:hidden text-white z-50 p-2"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Menú Mobile Overlay */}
      <div className={`fixed inset-0 bg-[#050505] z-40 transition-transform duration-500 ease-in-out lg:hidden overflow-y-auto pt-24 pb-10 px-6 ${
        isMobileOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="flex flex-col gap-6 mt-8">
          {menuData.map((item, index) => (
            <div key={index} className="border-b border-white/10 pb-4">
              <div className="flex justify-between items-center">
                <Link 
                  to={item.path} 
                  className={`text-lg font-serif tracking-widest uppercase ${item.isButton ? 'text-[#C5A059]' : 'text-white'}`}
                  onClick={() => !item.submenus && setIsMobileOpen(false)}
                >
                  {item.title}
                </Link>
                {item.submenus && (
                  <button 
                    onClick={() => setMobileDropdown(mobileDropdown === index ? null : index)}
                    className="text-[#C5A059] p-2"
                  >
                    <svg className={`w-5 h-5 transition-transform ${mobileDropdown === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                )}
              </div>
              
              {item.submenus && mobileDropdown === index && (
                <div className="flex flex-col gap-4 mt-4 pl-4 border-l border-[#C5A059]/30">
                  {item.submenus.map((subItem, subIndex) => (
                    <div key={subIndex}>
                      <Link 
                        to={subItem.path} 
                        className="text-sm font-sans tracking-widest text-gray-400 hover:text-white uppercase"
                        onClick={() => setIsMobileOpen(false)}
                      >
                        {subItem.title}
                      </Link>
                      {subItem.nested && (
                        <div className="flex flex-col gap-3 mt-3 pl-4 border-l border-white/10">
                          {subItem.nested.map((nestedItem, nIndex) => (
                            <Link 
                              key={nIndex} 
                              to={nestedItem.path} 
                              className="text-xs font-sans tracking-widest text-gray-500 hover:text-[#C5A059] uppercase"
                              onClick={() => setIsMobileOpen(false)}
                            >
                              {nestedItem.title}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;